import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getCompanyAddress } from '@helpers/companies';
import { ProfileName } from '@constants/integrations';

const AvailablePlatforms = {
    [ProfileName.Facebook]: 'facebookReviewsLink',
    [ProfileName.Google]: 'googleReviewsLink',
    [ProfileName.Instagram]: 'instagramLink',
    [ProfileName.TripAdvisor]: 'tripAdvisorReviewsLink',
    [ProfileName.Trustpilot]: 'trustpilotReviewsLink',
    [ProfileName.Yelp]: 'yelpReviewsLink',
    [ProfileName.Healthgrades]: 'healthgradesLink',
    [ProfileName.RateMDs]: 'rateMDsLink',
    [ProfileName.BBB]: 'bbbReviewsLink',
};

const Positive = ({ locationSurveyId, location, wording, languages, showSuggestion = true }) => {
    const iframeRef = useRef(null);
    const { watch, control } = useFormContext();

    const reviewPlatforms = watch('reviewPlatforms');
    const satisfactionSurveyEnabled = watch('satisfactionSurveyEnabled');
    const aiReviewSuggestionsEnabled = watch('aiReviewSuggestionsEnabled');
    const aiReviewTags = useWatch({ control, name: 'aiReviewTags' });

    useEffect(() => {
        const controller = new AbortController();
        const data = {
            locationName: location.locationName,
            businessAddress: getCompanyAddress(location.addressLine1, location.city),
            hasBusinessAddress: location.hasBusinessAddress,
            languages,
            ...wording,
            aiReviewSuggestionsEnabled: satisfactionSurveyEnabled && aiReviewSuggestionsEnabled && showSuggestion,
            aiReviewTags,
            links: reviewPlatforms.reduce((previous, current) => {
                return {
                    ...previous,
                    [AvailablePlatforms[current]]: current ? true : null,
                };
            }, {}),
        };
        iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-positive', data }, '*');
        const sendUpdatedData = event => {
            if (event.origin === import.meta.env.REACT_APP_SURVEY_DOMAIN) {
                const message = event.data;
                if (message.type === 'pl-preview-iframe-loaded') {
                    iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-positive', data }, '*');
                }
            }
        };
        window.addEventListener('message', sendUpdatedData, { signal: controller.signal });
        return () => controller.abort();
    }, [
        location,
        reviewPlatforms,
        languages,
        wording,
        satisfactionSurveyEnabled,
        aiReviewSuggestionsEnabled,
        aiReviewTags,
        showSuggestion,
    ]);

    return (
        <iframe
            ref={iframeRef}
            allow="autoplay; clipboard-write"
            width="100%"
            height="100%"
            src={`${import.meta.env.REACT_APP_SURVEY_DOMAIN}/preview/positive/${locationSurveyId}`}
            frameBorder="0"
        ></iframe>
    );
};

export default Positive;
